export default "__VITE_ASSET__ClLHkohR__"